import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Generic: ConvertableUnit = {
  label: "",
  toStandardUnit: g => g,
  toThisUnit: g => g
};

export const UnitedStatesDollar: ConvertableUnit = {
  label: "USD",
  toStandardUnit: usd => usd,
  toThisUnit: usd => usd
};

export const RevolutionsPerMinute: ConvertableUnit = {
  label: "RPM",
  toStandardUnit: rpm => rpm,
  toThisUnit: rpm => rpm
};

export const BarrelPerStockTankBarrel: ConvertableUnit = {
  label: "bbl/stb",
  toStandardUnit: bblstb => bblstb,
  toThisUnit: bblstb => bblstb
};

export const CubicFeetPerStandardCubicFeet: ConvertableUnit = {
  label: "cf/scf",
  toStandardUnit: cfsfc => cfsfc,
  toThisUnit: cfsfc => cfsfc
};

export const GenericUnits = {
  Generic,
  UnitedStatesDollar,
  RevolutionsPerMinute,
  BarrelPerStockTankBarrel,
  CubicFeetPerStandardCubicFeet,
  options: buildOptions([])
};
